<style>
</style>

<template>
  <v-app>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :multi-line="false"
      :timeout="snackbarTimeout"
    >
      {{ snackbarMessage }}
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-container fill-height>
      <v-card width="400" class="mx-auto mt-5 mb-12">
        <v-card-title class="deep-purple white--text">
          <h2>Password recovery</h2>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation @keyup.native.enter="validate">
            <v-text-field
              label="Email"
              v-model="email"
              :rules="emailRules"
              prepend-icon="mdi-account-circle"
              required
            />
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn :disabled="!valid" color="deep-purple white--text" class="mr-4" @click="validate">
            <v-icon>mdi-email-send</v-icon>Send reset token
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: "PasswordRecovery",
  components: {},
  data: () => ({
    valid: false,
    snackbar: false,
    snackbarColor: "red darken-3",
    snackbarTimeout: 6000,
    snackbarMessage: "",
    email: "",
    emailRules: [
      v => !!v || "Email is required",
      v =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail must be valid"
    ]
  }),
  created() {
    this.$vuetify.theme.dark = this.$store.state.themeDarkEnabled;
  },
  methods: {
    displayError(message) {
      this.snackbarMessage = message;
      this.snackbar = true;
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.$axios
          .get(
            `/users/${this.email}/password?reset_url_base=${encodeURIComponent(
              window.location.href.replace(/recovery$/, "reset")
            )}`
          )
          .then(() => {
            this.$router.push("/password-reset/" + this.email + "/");
          })
          .catch(result => {
            if (
              result.response.data.error &&
              result.response.data.error.message
            ) {
              this.displayError(result.response.data.error.message);
            } else {
              this.displayError(result.message);
            }
          });
      }
    }
  }
};
</script>
